export default __webpack_public_path__ + "assets/eco.6e18d38e.svg";